(function () {
  'use strict';

  if (window.__monteLandingRevealReady) return;
  window.__monteLandingRevealReady = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var revealSelector = [
    '.monte-lp__brandbar-inner',
    '.monte-lp__hero-copy',
    '.monte-lp__hero-card',
    '.monte-lp__photo',
    '.monte-lp__copy',
    '.monte-lp__capacity-image',
    '.monte-lp__capacity-copy',
    '.monte-lp__blackbar-inner > *',
    '.monte-lp__use-grid article',
    '.monte-lp__compare-image',
    '.monte-lp__compare-copy',
    '.monte-lp__colors h2',
    '.monte-lp__colors-image',
    '.monte-lp__edition',
    '.monte-lp__review-heading',
    '.monte-lp__review-grid article',
    '.monte-lp__cta-image',
    '.monte-lp__cta-copy',
    '.monte-lp__faq-wrap'
  ].join(',');

  function revealType(el) {
    if (
      el.matches('.monte-lp__photo, .monte-lp__capacity-image, .monte-lp__compare-image, .monte-lp__cta-image, .monte-lp__colors-image')
    ) {
      return 'scale';
    }

    if (el.matches('.monte-lp__hero-copy, .monte-lp__copy, .monte-lp__capacity-copy, .monte-lp__compare-copy, .monte-lp__cta-copy')) {
      return 'up';
    }

    if (el.matches('.monte-lp__hero-card:nth-child(odd), .monte-lp__use-grid article:nth-child(odd), .monte-lp__review-grid article:nth-child(odd)')) {
      return 'left';
    }

    if (el.matches('.monte-lp__hero-card:nth-child(even), .monte-lp__use-grid article:nth-child(even), .monte-lp__review-grid article:nth-child(even)')) {
      return 'right';
    }

    return 'up';
  }

  function delayFor(el, index) {
    var group = el.closest('.monte-lp__hero-gallery, .monte-lp__use-grid, .monte-lp__review-grid, .monte-lp__blackbar-inner');
    if (!group) return Math.min(index * 45, 140);

    var siblings = Array.prototype.filter.call(group.children, function (child) {
      return child.matches('[data-monte-reveal], article, .monte-lp__hero-card, span, strong');
    });
    var groupIndex = Math.max(0, siblings.indexOf(el));
    return Math.min(groupIndex * 90, 360);
  }

  function markVisible(el) {
    el.classList.add('is-visible');
  }

  function setup(root) {
    root = root || document;

    var items = Array.prototype.slice.call(root.querySelectorAll(revealSelector)).filter(function (el) {
      return !el.closest('.shopify-section[hidden]') && !el.dataset.monteRevealBound;
    });

    if (!items.length) return;

    items.forEach(function (el, index) {
      el.dataset.monteReveal = revealType(el);
      el.dataset.monteRevealBound = 'true';
      el.style.setProperty('--monte-reveal-delay', delayFor(el, index) + 'ms');
    });

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(markVisible);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          markVisible(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup(document);
    });
  } else {
    setup(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });
})();
